import moment from "moment";

import React, { createRef, useEffect, useState } from "react";
import { Button, Form, InputGroup, Modal, Spinner, Toast, ToastContainer } from "react-bootstrap";
import InputGroupText from "react-bootstrap/esm/InputGroupText";

import { Datatable } from "../../../shared/datatable/Datatable";
import { TextInput } from "../../../shared/form/FormInput";
import { getErrorMessage, uploadLargetAsset } from "../../../utils/utils";

import { aiQuestionGeneratepdf, aiQuestionGeneratePrompt, assessmentAdd, assessmentList, assessmentTemplateDetail, assessmentTemplateList, fileAssemble } from "../../../shared/settings/apiConfig";
import { postApi } from "../../../shared/services/apiHelper";

import './AssessmentList.scss';
import { CopyIcon } from "../../../shared/icons/Icons";

const uploadNameList = [
    { id: 1, value: "Web" },
    { id: 2, value: "Device" }
];
const complexityList = [
    { id: 1, value: "30", label: "Level 1", },
    { id: 2, value: "50", label: "Level 2", },
    { id: 3, value: "70", label: "Level 3", }
];

const option = [
    {
        name: "craft from scratch",
        link: "/assessments/create",
        icon: "craftfromscratch",
    },
    {
        name: "create using AI",
        link: "",
        icon: "createusingai",
    },
    {
        name: "create from file",
        link: "",
        icon: "createfromfile",
    },
    {
        name: "create from pool",
        link: "",
        icon: "createfrompool",
    },
]

const initialFileState = {
    pagefrom: { value: '', valid: false, error: '', },
    pageto: { value: '', valid: false, error: '', },
    keywords: { value: '', valid: true, error: '', },
    complexity: { value: '30', valid: true, error: '', },

  };
export const AssessmentList = (props) => {

    const [search, setSearch] = useState("");
    const [constModal, setConstModal] = useState({ show: false });
    const [createFromFile, setCreateFromFile] =  useState(initialFileState)

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const customDate = (dataValue) => {
        if (dataValue) {
            let date = moment.utc(dataValue).local();
            return `${date.format('DD/MM/YYYY')}`;
        } else
            return '- - -';
    };
    const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
    
      useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);   
    const customEdit = (row) => {
        return row.islatestversion && row.assessmentcode == null ? <img src={`${process.env.PUBLIC_URL}/static/icons/table/edit.svg`} alt={"edit"} className="action-button" onClick={() => { props.history.push(`/assessments/edit/${row.id}`); }} /> : null;
    };

    const [config, setConfig] = useState({
        name: 'assessment',
        url: assessmentList,
        columns: [
            // { name: '', property: '', width: '50px', columnType: 'custom', customColumn: (event) => checkBox(event) },
            { name: 'Assessor', property: 'addedby', sort: true, width: '200px' },
            { name: 'Assessment Name', property: 'assessmentname', sort: true, width: '250px' },
            { name: 'Programme Name', property: 'programmename', sort: false, showTooltip: true, width: '200px' },
            { name: 'Modified Date', property: 'updateddate', sort: false, width: '150px', customColumn: customDate },
            {
                name: '', property: '', width: '50px', columnType: 'actions', actions: {
                    row: [
                        { type: 'custom', action: customEdit }
                    ]
                }
            }
        ],
        field: ['id', 'assessmentname', 'subtitle', 'description', 'createddate','programmeid', 'updateddate','programmename', 'isdeleted', 'islatestversion', 'addedby', 'assessmentcode'],
        filter: [{ field: 'isdeleted', value: 0, op: '=', 'join': 'AND' }, { field: 'islatestversion', value: 1, op: '=', 'join': 'AND' }],
        sort: [{ "field": "createddate", "direction": "desc" }],
        pagination: true,
    });

    const dataTable = createRef();
    const [selectedUploadId, setSelectedUploadId] = useState(1); 
    const [fileUrl, setUrl] = useState("");
    const [fileName, setFileName] = useState("");
    const [fileNameError, setFileNameError] =  useState('')
    const [toastState, setToastState] = useState({ show: false, type: '', message: '' });
    const [fileUploadStatus, setFileUploadStatus] = useState({ status: false, error: '' });

    const handleGetFileName = (e) => {
        e.preventDefault();
        if (!fileUrl) {
          return;
        }
      
        try {
          // Extract filename from direct links
          const fileUrlpath = new URL(fileUrl);
          const filePath = fileUrlpath.pathname;
          const fileNameFromPath = filePath.split('/').pop();
      
          // If the filename contains ".pdf", return it
          if (fileNameFromPath.toLowerCase().endsWith('.pdf')) {
            setFileName(fileNameFromPath);
            setFileNameError('');
            return;
          }
      
          // Check for Google Drive link
          const driveMatch = fileUrl.match(/\/d\/([a-zA-Z0-9_-]+)/);
          if (driveMatch) {
            setFileName(`${driveMatch[1]}.pdf`); // Assigning file ID as filename (since we can't fetch actual name)
            setFileNameError('');
            return;
          }
      
          // If nothing matches, show error
          setFileNameError('Only PDF files are allowed');
        } catch (error) {
          setFileNameError('Invalid URL or only PDF files are allowed');
        }
      };
      
  const changeFileMode = (e) =>{
    setSelectedUploadId(parseInt(e.target.value))
    setUrl('')
    setFileName('')
    setFileNameError('')
    setConstModal(prevState => {
        return {
            ...prevState, data: {
                ...prevState.data,
                error:""
            }
        }
    })
  }

    /* custom checbox */
    // const checkBox = (value) => {
    //     return (
    //         <div>
    //             <Form>
    //                 <Form.Check className="d-flex align-items-center justify-content-center" type="checkbox" label="" value={value?.id} />
    //             </Form>
    //         </div>
    //     );
    // }
    
    const openFolder = () => {
        let input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf,'

        input.onchange = async (event) => {
            if (event.target.files?.length > 0) {
                onChangeFile(event.target.files[0]);
            }
        }

        input.click();
    };

    const onChangeFile = async (file) => {
        const asset = { name: file.name, size: file.size, file };
        setFileName(file.name)
        setFileUploadStatus({status: true, error: ''});

        let response = await uploadLargetAsset(asset);

        if (response.status) {

            delete asset.file;

            postApi(fileAssemble, { data: asset }).then(response => {
                setConstModal(prevState => {
                    prevState.data.pdf = response.data.data.url;
                    prevState.data.rawpdf = file;
                    prevState.data.error="";
                    return { ...prevState };
                });
                setFileUploadStatus({status: false, error: ''});
            }).catch(error => {
                console.log(error);
                setFileUploadStatus({status: true, error: ''});
            });
        }
    }

    const generateQuestionUsingAI = () => {
        let url = null, payload = null;
        
        if ( constModal?.data?.name == option[1].name ) {
            url = aiQuestionGeneratePrompt
            payload = {
                question_type: 0,
                no_of_questions: Number(constModal?.data?.noq),
                prompt: constModal?.data?.prompt,
            }
        } else {
            url = aiQuestionGeneratepdf;
            payload = {
                question_type: 0,
                no_of_questions: Number(constModal?.data?.noq),
                pdf_file: constModal?.data?.pdf ? constModal?.data?.pdf : fileUrl ? fileUrl : '',
                start_page:Number(createFromFile.pagefrom.value),
                end_page:   Number(createFromFile.pageto.value),
                // keywords: createFromFile.keywords.value,
                complexity:  Number(createFromFile.complexity.value),
            }
        }

        postApi(url, { data: payload }).then(response => {
            let questionList =  ((Array.isArray(response.data.data) && response.data.data) || []).filter(i => i?.questionname);
            if ( questionList.length > 0 ) {
                setConstModal(prevState => {
                    return {
                        ...prevState, 
                        data: {
                            ...prevState.data,
                            type: "ViewQuestion",
                            questions: questionList,
                            loading: false
                        }
                    }
                });
            } else {
                setConstModal(prevState => {
                    return {
                        ...prevState, 
                        data: {
                            ...prevState.data,
                            loading: false,
                            error: "Please try again and if issue persist contact Helpdesk"
                        }
                    }
                });
            }
        }).catch((error) => {
            setConstModal(prevState => {
                return {
                    ...prevState, 
                    data: {
                        ...prevState.data,
                        loading: false,
                        error: error?.response?.data?.message ? error?.response?.data?.message : error?.message
                    }
                }
            });
        });
    };

    const setCreateFileData = (type, event) => {
        const value = event.target.value.trim();
        setCreateFromFile(prevState => ({
            ...prevState,
            [type]: {
                ...prevState[type],
                value: value,
                valid: value !== "", 
                error: value === "" ? "Please enter the value" : "" 
            }
        }));
    }


    const createAssessment = () => {
        let aiGeneratedQuestions = Array.isArray(constModal?.data?.questions) ? constModal.data.questions : [];
        aiGeneratedQuestions = aiGeneratedQuestions.filter(elem => { return elem.selected; });

        if (aiGeneratedQuestions.length > 0) {
            setConstModal({ show: false, data: {} });
            props.history.push(`/assessments/create/`, { aiGeneratedQuestions: aiGeneratedQuestions, title: constModal?.data?.name });
        }
        else {
            setConstModal(prevState => {
                return {
                    ...prevState, 
                    data: {
                        ...prevState.data,
                        loading: false,
                        error: "Please select Questions"
                    }
                }
            });
        }
    }
    const closeModel = () => {
        setConstModal({ show: false, data: {} }) 
        setFileName('')
        setUrl('')
        setSelectedUploadId(1)
        setFileNameError('')
        setCreateFromFile(initialFileState)
    }

    const validateGenerateButton = () => {
        if ( constModal?.data?.name == option[1].name ) {
            if ( constModal?.data?.noq && constModal?.data?.prompt && Number(constModal?.data?.noq) <= 20) {
                return false;
            }
        } else {
            if ( constModal?.data?.noq && Number(constModal?.data?.noq) <= 20 && constModal?.data?.pdf ) {
                return false;
            }
        }

        return true;
    };

    const isFormValid = Object.values(createFromFile).every(field => field.valid);
    const noqValue = Number(constModal?.data?.noq); 
    const isNoqInvalid = !constModal?.data?.noq || isNaN(noqValue) || noqValue > 20; 
    const isUploadValid = fileName !== "";
    const isDisabled = constModal?.data?.name === option[2].name ? ( !isFormValid  || isNoqInvalid || !isUploadValid) : false;
    console.log(isDisabled)


    return (
        <div>
            <div className="assessmet-list-container">
                <text className='screen-head'>Assessments</text>
            <div className="d-flex w-100 align-items-center py-2">
                <div className='   w-50 d-flex align-items-center  '>
                    <img className={"ms-2"} width={"25px"} src={`${process.env.PUBLIC_URL}/static/images/editing.png`} alt={"editing"} />
                    <text className='screen-sub-head my-1'>Create Assessments</text>
                </div>
            </div>
            <div className="d-flex">
                {option.map((item, index) => (
                    <div className="w-100 create-assessment-list" >
                        {<div role={"button"} className={`shadow-lg align-items-center rounded W-100 py-1  my-2 mx-2`}
                            onClick={() => {
                                if (item.link != "") {
                                    props.history.push(item.link,{title:item?.name})
                                } else {
                                    if ( item.name == 'create from pool' ) {
                                        const payload = {
                                            "field": ["assessmentname", "description"]
                                        };
                                        postApi(assessmentTemplateList, payload).then(response => {
                                            setConstModal({
                                                show: true,
                                                data: {
                                                    type: 'createFromPool',
                                                    name: item.name,
                                                    icon: item.icon,
                                                    list: response.data.data
                                                }
                                            })
                                        }).catch(error => {
                                            console.log(error);
                                        });
                                    } else {
                                        setConstModal({
                                            show: true,
                                            data: {
                                                type: "uploadUI",
                                                name: item.name,
                                                icon: item.icon
                                            }
                                        })
                                    }
                                }
                            }}
                        >
                            <div class="d-flex  justify-content-center">
                                <img className={"m-2 w-60 h-60"} src={`${process.env.PUBLIC_URL}/static/images/${item?.icon}.jpg`} alt={item?.name} />
                            </div>
                            <div className=" d-flex  justify-content-center align-items-center  ">
                                <div className="head-name">{item?.name}</div>
                            </div>
                        </div>}
                    </div>
                ))}
            </div>

            <div className="d-flex w-100 align-items-center py-2 px-3  ">
                <div className='  w-50 d-flex align-items-center  '>
                    <img className={"ms-2"} width={"25px"} src={`${process.env.PUBLIC_URL}/static/images/menu.png`} alt={"menu"} />
                    <text className='screen-sub-head my-1'>Active Assessments</text>
                </div>
                <div className='d-flex w-100 justify-content-end align-items-center'>
                    <div className="w-75 mx-3 d-flex">
                        <InputGroup className="">
                            <InputGroupText className="signicon search" >
                                <i class="fa fa-search text-primary" ></i>
                            </InputGroupText>
                            <span class="icon-envelope-o"></span>
                            <Form.Control className={`signinput search`} size="md" type={'text'} name={"search"} placeholder={"search by assessment name"} value={search}
                                onChange={(event) => { setSearch(event.target.value) }} autoComplete="off" onKeyPress={(event) => {
                                    if (event?.key === "Enter")
                                        dataTable.current?.searchData([{ field: 'assessmentname', value: `*${search}*`, op: 'LIKE', 'join': 'AND' }])
                                }} />
                            <InputGroupText role={"button"} className="border border-1 search  bg-primary" onClick={() => {
                                dataTable.current?.searchData([{ field: 'assessmentname', value: `*${search}*`, op: 'LIKE', 'join': 'AND' }])
                            }}>
                                {windowWidth > 800 ? <div className="text-white">Search</div> : <i class="fa fa-search text-white" ></i>}
                            </InputGroupText>
                            <Button className="bg-secondary" type="button" style={{ marginLeft: '3px',zIndex:0 }} onClick={(event) => {
                                setSearch("")
                                    dataTable.current?.searchData([])
                                }}>
                                {windowWidth > 800 ? <div className="text-white">Clear</div> : <i class="fa fa-times text-white" ></i>}</Button>
                        </InputGroup>
                    </div>
                    {/* <button style={{ backgroundColor: "white" }} className="d-flex align-items-center border border-1 search py-1 rounded mx-1">
                        <img style={{ maxWidth: "30px" }} className={"mx-2 w-20 h-20"} src={`${process.env.PUBLIC_URL}/static/images/export.png`} alt={"export"} />
                        <text className="text-primary text-s">Export</text>
                    </button> */}
                </div>
            </div>
            </div>
            <div style={{ padding: '15px' }}>
                <Datatable ref={dataTable} config={config} />
            </div>
            <Modal centered show={constModal.show} size={"lg"} animation={true}>
                <Modal.Header className="modal-header"> 
                    <div className="d-flex flex-column">
                        <div className="d-flex align-items-center">
                            <img width="50px" className="mx-1" src={`${process.env.PUBLIC_URL}/static/images/${constModal?.data?.icon}.jpg`} alt="ai" />
                            <div className="modal-head">{constModal?.data?.name}</div>
                        </div>
                        <div className="mt-2">
                            { constModal?.data?.name == option[1].name && <span className="text-danger w-100 text-center ">The question generated from AI are for reference only , Assessor have to validate and alter if required</span>}
                        </div>
                    </div>
                    <div className="cursor-pointer close-icon" onClick={() => closeModel()}>X</div>
                </Modal.Header>
                <Modal.Body>
                    {
                        constModal?.data?.type == "ViewQuestion" &&
                        <div className="d-flex flex-column gap-3">
                                <div className="">
                                    <Form.Check className="font-weight-bold"
                                        type="checkbox" label={"Select All"}
                                        checked={constModal?.data?.questions?.filter(i => (!("selected" in i) || i?.selected == false)).length > 0 ? false : true}
                                        onChange={(event) => {
                                            let ques =  constModal?.data?.questions
                                            ques = ques.map(i => { return ({ ...i,selected: event.target.checked,  }) })
                                            setConstModal(prevState => {
                                                return { ...prevState, data: { ...prevState?.data, questions: ques,error:"" } };
                                            });
                                        }} />
                                </div>
                            {
                                Array.isArray(constModal?.data?.questions) && constModal.data.questions.map((question, qindex) => (
                                    <div>
                                        <Form.Check className="font-weight-bold assessment-question w-100"
                                            key={`ai-question-${question.questionuniqueid}-${qindex}`}
                                            type="checkbox" label={question.questionname}
                                            id={`ai-question-${question.questionuniqueid}-${qindex}`}
                                            value={`ai-question-${question.questionuniqueid}-${qindex}`}
                                            checked={question?.selected}
                                            onChange={(event) => {
                                                setConstModal(prevState => {
                                                    let data = {...prevState?.data}
                                                    data["error"] =""
                                                    data.questions[qindex].selected = event.target.checked;
                                                    
                                                    return { ...prevState,data };
                                                });
                                            }} />
                                            

                                        <div className="mx-5">
                                            {
                                                Array.isArray(question.optionset) && question.optionset.map((set, setIndex) => (
                                                    <div>
                                                        <div className="font-weight-bold">Set {setIndex + 1}</div>
                                                        <div className="mx-5">
                                                            {
                                                                Array.isArray(set.options) && set.options.map((option) => (
                                                                    <div className="d-flex gap-5">
                                                                        <div className="w-50">{option.optionname}</div>
                                                                        <div className="justify-content-end">{option.score}</div>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ))
                            }  
                            <div className="d-flex justify-content-center ">
                                {constModal?.data?.error && <div className="text-danger ">{constModal?.data?.error}</div>}
                            </div>
                            <div className="d-flex my-3  align-items-center justify-content-center ">
                                <Button className="btn btn-primary" onClick={createAssessment}>Create Assessment</Button>
                            </div>
                        </div>
                    }
                    {
                        constModal?.data?.type == "uploadUI" &&
                        <div>
                                {
                                    constModal?.data?.name == option[1].name ?
                                    <div className="w-100 my-3">
                                        <textarea autoFocus className="upload-component" name={'prompt'} label={'Enter Prompt or Paste text'} placeholder={'Enter Prompt or Paste text'} value={constModal?.data?.prompt}
                                            disabled={(constModal?.data?.loading || constModal?.data?.rawpdf)}
                                            onChange={(event) => {
                                                setConstModal(prevState => {
                                                    return {
                                                        ...prevState, data: {
                                                            ...prevState.data,
                                                            prompt: event.target.value,
                                                            error:""
                                                        }
                                                    }
                                                })
                                            }} />
                                    </div> :
                                    
                                    <div>
                                    <div className="question-container gap-3 d-flex">
                                        <label className="question-label flex-grow-0 font-weight-bold">Select / Upload File</label>
                                        <div className="input-section w-60">
                                            <Form className="run-type-controls d-flex">
                                                {
                                                    uploadNameList.map((elem, index) => (
                                                        <Form.Check key={"Upload-" + elem.id} type="radio" style={{ marginRight: '20px' }} name="UploadList" id={`Upload-${elem.id}`} value={elem.id} label={elem.value} defaultChecked={elem.id === selectedUploadId} onChange={(event) => changeFileMode(event)} />
                                                    ))
                                                }
                                            </Form>
                                            {/* <span className="text-danger"> */}
                                                {/* Error message (if any) */}
                                            {/* </span> */}
                                        </div>
                                    </div>

                                    <div className="question-container gap-3 d-flex">
                                        <div className="question-label"></div>
                                        <div className="input-section">
                                            <Form className="run-type-controls d-flex">
                                                {
                                                    selectedUploadId === 1
                                                        ? <><Form.Control type="text" style={{ borderRadius: '5px 0px 0px 5px', width: '65%' }} value={fileUrl} onChange={(e) => setUrl(e.target.value)} /><Button disabled={fileUrl == ""} onClick={handleGetFileName} className="file-upload-btn">Get</Button></>
                                                        : <><Form.Control type="text" style={{ borderRadius: '5px 0px 0px 5px', width: '65%' }} disabled  value={fileName} /><button  onClick={(e) => {
                                                            e.preventDefault();
                                                            
                                                                openFolder()
                                                                setConstModal(prevState => {
                                                                    return {
                                                                        ...prevState, data: {
                                                                            ...prevState.data,
                                                                            error:""
                                                                        }
                                                                    }
                                                                })
                                                              }} className="file-upload-btn" >Browse File</button></>
                                                }
                                            </Form>
                                            <span className="text-danger text-s">
                                                {fileNameError}
                                            </span>
                                        </div>
                                    </div>

                                    {
                                        fileName && 
                                        <div className="question-container mt-3 gap-3 d-flex">
                                            <label className="question-label flex-grow-0 font-weight-bold">Fetched Record</label>
                                            <div className="input-section w-60">
                                                {
                                                    fileUploadStatus.status ? 
                                                    <span className="text-s text-warning">Uploading file... Please wait</span> : 
                                                    <div>
                                                        <span style={{ marginRight: '5px' }}>
                                                            <img src={`${process.env.PUBLIC_URL}/static/images/pdf.png`} style={{ width: '20px' }} alt="" />
                                                        </span>
                                                        {
                                                            fileUrl ?
                                                            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                {fileName}
                                                            </a> :
                                                            <span>{fileName}</span>
                                                        }
                                                    </div>
                                                }
                                                <span className="text-danger">
                                                    {/* Error message (if any) */}
                                                </span>
                                            </div>
                                        </div>
                                    }

                                    <div className="question-container  d-flex align-items-center my-3 gap-3">
                                        <label className="question-label flex-grow-0 font-weight-bold">Take Questions from</label>
                                        <div className="input-section d-flex">
                                            <div style={{width: '40%'}}>
                                            <TextInput className={'w-100'} name={'pageFrom'} placeholder={'Page from'}
                                                disabled={constModal?.data?.loading} onChange={(event)=>{setCreateFileData("pagefrom",event)
                                                setConstModal(prevState => {
                                                    return {
                                                        ...prevState, data: {
                                                            ...prevState.data,
                                                            error:""
                                                        }
                                                    }
                                                })}} 
                                                error={createFromFile.pagefrom.error} ignoreDefaultErrorSpace type={"number"}  value={createFromFile.pagefrom.value}
                                                />
                                            
                                            </div>
                                           
                                            <Form.Label className="mx-3 align-items-center d-flex">To</Form.Label>
                                            <TextInput className={'w-75'} name={'pageTo'} placeholder={'Page To'}
                                                disabled={constModal?.data?.loading} 
                                                value={createFromFile.pageto.value} onChange={(event)=>{setCreateFileData("pageto",event)
                                                setConstModal(prevState => {
                                                    return {
                                                        ...prevState, data: {
                                                            ...prevState.data,
                                                            error:""
                                                        }
                                                    }
                                                })}} 
                                                error={createFromFile.pageto.error} ignoreDefaultErrorSpace type={"number"} />
                                        </div>
                                    </div>
                                    <div className="question-container d-flex align-items-center my-3 gap-3">
                                        <label className="question-label flex-grow-0 font-weight-bold">Topics / Keywords</label>
                                        <div className="input-section flex-grow-1">
                                            <TextInput className={'input-answer'} name={'keywords'} placeholder={'Topic/Keywords'}
                                                disabled={constModal?.data?.loading} onChange={(event)=>{setCreateFileData("keywords" ,event)
                                                setConstModal(prevState => {
                                                    return {
                                                        ...prevState, data: {
                                                            ...prevState.data,
                                                            error:""
                                                        }
                                                    }
                                                })}}  error={createFromFile.keywords.error}
                                               ignoreDefaultErrorSpace />
                                        </div>
                                    </div>

                                    <div className=" question-container d-flex align-items-center my-3 gap-3">
                                        <label className="question-label flex-grow-0 font-weight-bold">Complexity</label>
                                        <div className="input-section flex-grow-1">
                                            <Form className="run-type-controls d-flex">
                                                {
                                                    complexityList.map((elem, index) => (
                                                        <Form.Check key={"complexity-" + elem.id} checked={createFromFile.complexity.value === elem.value} type="radio" style={{ marginRight: '20px' }} onChange={(event)=>{setCreateFileData("complexity",event)
                                                        setConstModal(prevState => {
                                                            return {
                                                                ...prevState, data: {
                                                                    ...prevState.data,
                                                                    error:""
                                                                }
                                                            }
                                                        })}} name="complexity" id={`complexity-${elem.id}`} value={elem.value} label={elem.label} />
                                                    ))
                                                }
                                            </Form>
                                        </div>
                                    </div>
                                </div>}

                                    <div className="question-container d-flex align-items-center my-3 gap-3">
                                        <label className="question-label flex-grow-0 font-weight-bold">Number of questions</label>
                                        <div className="input-section flex-grow-1">
                                            <TextInput className={'input-answer'} name={'noq'} placeholder={'Count (max 20)'} value={constModal?.data?.noq}
                                                disabled={constModal?.data?.loading}
                                                error={constModal?.data?.noq && Number(constModal?.data?.noq) > 20 ? "maximum number of question is 20" : ""}
                                                max={20}
                                                onChange={(event) =>
                                                    setConstModal(prevState => {
                                                        return {
                                                            ...prevState, data: {
                                                                ...prevState.data,
                                                                noq: event.target.value,
                                                                error: ""
                                                            }
                                                        }
                                                    })} ignoreDefaultErrorSpace type={"number"} />
                                        </div>
                                    </div>


                                    <div className="d-flex justify-content-center ">
                                        {constModal?.data?.error && <div className="text-danger ">{constModal?.data?.error}</div>}
                                    </div>
                                    <div className="d-flex my-3  align-items-center justify-content-center ">
                                    <Button className="me-5" onClick={() => closeModel()}>Cancel</Button>
                                        <Button className="btn btn-primary" disabled={constModal?.data?.loading || isDisabled  || validateGenerateButton()} onClick={() => {
                                            setConstModal(prevState => {
                                                return {
                                                    ...prevState,
                                                    data: {
                                                        ...prevState.data,
                                                        loading: true
                                                    }
                                                }
                                            });
                                            generateQuestionUsingAI()
                                        }}>Generate {constModal?.data?.loading && <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" />}</Button>
                                    </div>
                        </div>
                    }
                    {
                        constModal?.data?.type == 'createFromPool' &&
                        <div className="create-from-pool-container">
                            <h5 className="fw-bold p-2">Psychological Templates</h5>
                            <div className="d-flex flex-column gap-3">
                                {
                                    constModal.data.list.map((template) => (
                                        <div key={template._id} className="card-view d-flex align-items-center justify-content-between gap-2">
                                            <div>
                                                <h6 className="fw-bold">{template.assessmentname}</h6>
                                                <div>{template.description}</div>
                                            </div>
                                            <Button onClick={() => {
                                                postApi(assessmentTemplateDetail + template._id, {filter: []}).then(response => {
                                                    if ( Array.isArray(response.data.data) && response.data.data.length > 0 ) {
                                                        postApi(assessmentAdd, { data: response.data.data[0] }).then(response => {
                                                            setToastState({show: true, type: 'success', message: 'Template imported successfully!..'});
                                                            setConstModal({ show: false, data: {} });
                                                            dataTable.current?.searchData([]);
                                                        }).catch((error) => {
                                                            setToastState({show: true, type: 'danger', message: getErrorMessage(error)});
                                                        });
                                                    } else {
                                                        setToastState({show: true, type: 'danger', message: 'No template found'});
                                                    }
                                                }).catch(error => {
                                                    setToastState({show: true, type: 'danger', message: 'Error while fetching templates'});
                                                })
                                            }}>+ Create Template</Button>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }
                </Modal.Body>
            </Modal>

            <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
                <Toast show={toastState.show} bg={toastState.type} onClose={() => setToastState({ ...toastState, show: false })} autohide delay={2000}>
                    <Toast.Body className="text-white">
                        {toastState.message}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    );
}